<template>
    <form method="post" @submit.prevent="submit" novalidate>
        <div class="form-group" :class="{'error-shake has-invalid': $v.form.email.$error}">
            <label for="email-J0wLF4Fc" class="control-label sr-only">E-mailadres</label>
            <input type="email" id="email-J0wLF4Fc" placeholder="E-mailadres" class="form-control" v-model.trim.lazy="$v.form.email.$model">
            <div class="help-text" v-if="$v.form.email.$error">
                <p v-if="!$v.form.email.email">Geen geldig e-mailadres</p>
            </div>
        </div>
        <div class="form-group" :class="{'error-shake has-invalid': $v.form.password.$error}">
            <label for="password-u5V3FIYf" class="control-label sr-only">Wachtwoord</label>
            <input type="password" name="password" id="password-u5V3FIYf" placeholder="Wachtwoord" class="form-control" v-model.trim.lazy="$v.form.password.$model">
        </div>
        <div class="d-flex justify-content-start align-items-center">
            <button type="submit" class="btn btn-primary btn-caret" ref="btn">Inloggen</button>
            <div class="custom-control custom-checkbox ml-4 small">
                <input type="checkbox" id="logged-in" class="custom-control-input" v-model="$v.form.remember.$model">
                <label for="logged-in" class="custom-control-label">Ik wil ingelogd blijven</label>
            </div>
        </div>
        <div v-if="passwordResetUrl">
            <hr>
            <a :href="passwordResetUrl" class="btn-link-white">Wachtwoord vergeten?</a>
        </div>
    </form>
</template>

<script>
import {required, email} from 'vuelidate/lib/validators'

export default {
    props: {
        loginUrl: String,
        passwordResetUrl: String,
    },
    data() {
        return {
            form: {
                email: '',
                password: '',
                remember: false,
            }
        };
    },
    validations: {
        form: {
            email: {
                required,
                email,
            },
            password: {
                required,
            },
            remember: {}
        }
    },
    methods: {
        submit() {
            this.$refs.btn.blur();
            this.$v.$touch();

            if (this.$v.$anyDirty && !this.$v.$invalid) {
                let that = this;
                this.axios.post(this.loginUrl, this.form).then(response => {
                    window.location.href = response.data.redirect;
                }).catch(error => {
                    let msg = 'Er is een fout opgetreden.';

                    if (error.response && error.response.data && error.response.data.errors) {
                       for (let name in that.form) {
                           if (!that.form.hasOwnProperty(name)) {
                               continue;
                           }

                           if (error.response.data.errors[name] && error.response.data.errors[name][0]) {
                               msg = error.response.data.errors[name][0];
                               break;
                           }
                       }
                    }

                    that.$notify({
                        group: 'base',
                        text: msg,
                        type: 'alert-danger',
                    });
                });
            }
        }
    }
}
</script>
